import { RiBuildingLine } from "@remixicon/react";

import EmptyState, { EmptyStateProps } from "@/common/components/EmptyState";
import { IcoSegment } from "@/common/components/Icons";
import { SegmentDTO } from "@reflag/shared/segmentAPI";

type Props = EmptyStateProps & {
  segment: SegmentDTO;
  isFiltered?: boolean;
  isError?: boolean;
  onRetry?: () => void;
};

export default function UsersEmptyState({
  segment,
  isLoading,
  isError,
  isFiltered,
  onRetry,
  ...rest
}: Props) {
  if (segment.isAllSegment && !isFiltered) {
    return (
      <EmptyState
        description="Users will appear when initializing our SDKs."
        error="Failed to load users"
        flexGrow={1}
        icon={<RiBuildingLine size="48px" />}
        isError={isError}
        isLoading={isLoading}
        title="No users found"
        onRetry={onRetry}
        {...rest}
      />
    );
  }
  return (
    <EmptyState
      description="Try adjusting the filters. Tweak the table columns to show only what you need and save them for later!"
      error="Failed to load users"
      flexGrow={1}
      icon={<IcoSegment boxSize="48px" />}
      isError={isError}
      isLoading={isLoading}
      title="No users found"
      onRetry={onRetry}
      {...rest}
    />
  );
}
